function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "9218B93B-009B-47AC-8311-2954A3642F6E");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styles",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "LAP-Icons",
  transform: "translate(-387.000000, -218.000000)",
  fill: "#BCBFC2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Arrow-Down",
  transform: "translate(387.000000, 218.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7,8.88636175 L12.1645335,3.69576715 C12.4242871,3.43474428 12.8454311,3.43474428 13.1051847,3.69576715 C13.3649384,3.95679001 13.3649384,4.37999169 13.1051847,4.64101455 L7.47032563,10.3042329 C7.21057196,10.5652557 6.78942804,10.5652557 6.52967437,10.3042329 L0.894815257,4.64101455 C0.635061581,4.37999169 0.635061581,3.95679001 0.894815257,3.69576715 C1.15456893,3.43474428 1.57571285,3.43474428 1.83546653,3.69576715 L7,8.88636175 Z",
  id: "arrow-down"
}))));

var SvgArrowDownGray = function SvgArrowDownGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDownGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down-gray.ce51bb89.svg";
export { ForwardRef as ReactComponent };